// extracted by mini-css-extract-plugin
export default {"totalVotes":"UiRateRatingDetail_totalVotes","wrapperDetailBar":"UiRateRatingDetail_wrapperDetailBar","row":"UiRateRatingDetail_row","progressBar":"UiRateRatingDetail_progressBar"};